import React, { useId } from "react";

/**
 * Accessible Yes/No (or custom) radio group with fieldset/legend and error alert.
 */
const YesNoRadioGroup = ({
  legend,
  name,
  value,
  onChange,
  options = [],
  error,
  required = true,
}) => {
  const errorId = useId();
  const errorMessage =
    typeof error === "string" ? error : error?.message || null;

  return (
    <fieldset
      className="min-w-0 border-0 p-0 m-0"
      aria-describedby={errorMessage ? errorId : undefined}
    >
      <legend className="block text-sm font-medium text-gray-900 mb-3 px-0">
        {legend}
        {required && (
          <>
            <span className="text-red-700" aria-hidden="true">
              {" "}
              *
            </span>
            <span className="sr-only"> (required)</span>
          </>
        )}
      </legend>
      <div className="space-y-2">
        {options.map((option) => (
          <label key={option.value} className="flex items-center">
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={(e) => onChange(e.target.value)}
              required={required}
              className="mr-2 h-4 w-4 border-gray-400 text-custom-blue focus:ring-custom-blue"
            />
            <span className="text-gray-900">{option.label}</span>
          </label>
        ))}
      </div>
      {errorMessage && (
        <p id={errorId} role="alert" className="mt-1 text-sm text-red-700">
          {errorMessage}
        </p>
      )}
    </fieldset>
  );
};

export default YesNoRadioGroup;
